<template>
  <v-card class="rounded-xl">
    <div class="modern-header">
      <div class="header-content">
        <div class="header-left">
          <v-icon class="header-icon" size="20" color="white">mdi-equal-box</v-icon>
          <h2 class="header-title" style="text-transform: uppercase; font-size: 1.1rem">
            {{ getToolbarLabel }}
          </h2>
        </div>
        <div class="header-actions" v-if="showButtonClose">
          <v-btn icon large class="close-btn" @click="$emit('close')">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <v-container fluid class="px-1 pt-0 pb-4">
      <v-data-table dense :items=itemsLevels hide-default-footer :headers=headers>
        <template v-slot:item.AtsStatusName="{ item }">
          <v-chip x-small :color="item.AtsStatus == 2 ? 'success' : item.AtsStatus == 1 ? '' : 'error'"
            class="px-1 text-uppercase">
            {{ item.AtsStatus == 3 ? 'Desaprobado' : item.AtsStatusName }}</v-chip>
        </template>
        <template v-slot:item.TypeLevelText="{ item }">
          {{ formatDate(item.TypeLevelText) }}
        </template>
        <template v-slot:item.AtsAttach1="{ item }">
          <v-btn icon @click="openFile(item.AtsAttach1)" v-if="item.AtsAttach1">
            <v-icon>mdi-file-document</v-icon>
          </v-btn>
          {{ item.AtsAttach1 }}
        </template>
      </v-data-table>
    </v-container>
  </v-card>
</template>

<script>
import _sApprovalLevel from "@/services/Security/ApprovalLevelsService";
import _sGeneral from "@/services/HelperService.js";

export default {
  name: "ApprovalLevelsDocument",
  components: {},
  props: {
    DocEntry: null,
    TypeObject: null,
    showButtonClose: { type: Boolean, default: true },
  },
  data: () => ({
    headers: [
      { text: 'Cargo', value: 'PstName' },
      { text: 'Estado', value: 'AtsStatusName', width: 100 },
      { text: 'Fecha', value: 'TypeLevelText', width: 130 },
      { text: 'Comentario', value: 'AtsObservation' },
      { text: 'Adjunto', value: 'AtsAttach1' }
    ],
    itemsLevels: [],
  }),
  computed: {
    getToolbarLabel() {
      if (this.TypeObject === 2) {
        return "Lista de Aprobaciones de la Orden de Compra";
      } else if (this.TypeObject === 1) {
        return "Lista de Aprobaciones del requerimiento";
      } else if (this.TypeObject === 3) {
        return "Lista de Aprobaciones de Adelanto de Insumos";
      }
      return "Lista de Aprobaciones";
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return '';

      const [date, time] = value.split(' ');
      if (!date || !time) return '';

      const [dd, mm, yyyy] = date.split('-');
      if (!dd || !mm || !yyyy) return '';

      return `${dd}/${mm}/${yyyy} ${time}`;
    },
    openFile(name) {
      console.log("dow", name);
      _sGeneral.download(name, this.$fun.getUserID()).then((r) => {
        this.$fun.download(r.data, name);
      });
    },
  },
  watch: {
    DocEntry() {
      _sApprovalLevel.byDocument({ DocEntry: this.DocEntry, TypeApproval: this.TypeObject }, this.$fun.getUserID()).then((r) => {
        this.itemsLevels = r.data;
      });
    }
  },
  created() {
    _sApprovalLevel.byDocument({ DocEntry: this.DocEntry, TypeApproval: this.TypeObject }, this.$fun.getUserID()).then((r) => {
      this.itemsLevels = r.data;
      console.log(JSON.parse(JSON.stringify(r.data)))
    })

  },
  mounted() { },
};
</script>

<style scoped>
.modern-header {
  background: linear-gradient(135deg, #04abc5 0%, #04abc5 100%);
  padding: 8px;
  color: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  padding: 6px;
  border-radius: 10px;
  backdrop-filter: blur(10px);
}

.header-text,
.header-title {
  flex: 1;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1 1 0%;
}

.header-right {
  display: flex;
  justify-items: center;
  align-items: center !important;
  min-width: 300px;
}
</style>